import React from 'react';
import Accordion from 'components/Accordion';
import Snackbar from 'components/DesignSystem/Snackbar';
import ConfirmationButton from 'components/ConfirmationButton';
import useLocation from 'hooks/Meteorology/Agro/WaterBalanceSequential/DetailedView/useLocation';
import useDeleteLocation from 'hooks/Meteorology/Agro/useDeleteLocation';
import useSearchFilter from 'hooks/useSearchFilter';
import Searcher from 'components/DesignSystem/Searcher';
import RadioButton from 'components/DesignSystem/RadioButton';

export default function Location() {
  const {
    selectedLocation,
    locationOptions,
    onLocationClick,
  } = useLocation();
  const { searchTerm, onSearchChange, searchIncludes } = useSearchFilter();
  const filteredLocations = locationOptions.filter((loc) => searchIncludes(loc.name));

  const { deleteLocation } = useDeleteLocation();

  return (
    <Accordion.Item eventKey="location" id="location-accordion">
      <Accordion.Header>Local</Accordion.Header>
      <Accordion.Body>
        {locationOptions.length === 0 && (
          <Snackbar>
            Nenhum local disponível para o grupo selecionado.
          </Snackbar>
        )}
        {locationOptions.length > 0 && (
          <>
            <Searcher
              className="mb-2"
              value={searchTerm}
              onChange={onSearchChange}
            />
            {filteredLocations?.map((location) => (
              <div
                id={`location-checkbox-${location.id}`}
                className="d-flex justify-content-between align-items-center"
                key={location.id}
              >
                <RadioButton
                  label={location.name}
                  checked={location.id === selectedLocation}
                  onChange={onLocationClick(location.id)}
                />
                <ConfirmationButton
                  id={`delete-location-${location.id}`}
                  type="tertiary"
                  onClick={() => deleteLocation(location.id)}
                  icon="trash"
                  confirmationBody={(
                    <p>
                      Tem certeza que deseja excluir o local
                      {' '}
                      <strong>{location.name}</strong>
                      ?
                    </p>
                  )}
                />
              </div>
            ))}
          </>
        )}
      </Accordion.Body>
    </Accordion.Item>
  );
}
